import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const CARDS = [
  {
    to: "/tradition",
    overline: "Seit 1949",
    title: "Tradition",
    text: "Zwei Generationen, ein Versprechen. Die Geschichte der Casa Markus.",
    img: "https://customer-assets.emergentagent.com/job_5adba607-3cb4-4890-a176-530c0c902f8d/artifacts/ssy7xi7j_imgi_2_Banner_Familie.png",
    bg: "bg-[#f7f3ec]",
  },
  {
    to: "/service",
    overline: "Werkstatt",
    title: "Service",
    text: "MFK, Reparatur, Wartung — Handwerk seit über 75 Jahren.",
    img: "https://customer-assets.emergentagent.com/job_vespa-basel-relaunch/artifacts/r465wro9_imgi_2_thumbnail_IMG_8296-3.jpg",
    bg: "bg-[#eef0ec]",
  },
  {
    to: "/vespa-piaggio",
    overline: "Showroom",
    title: "Vespa",
    text: "GTS, Primavera, Sprint, 946 Anniversario — neu & geprüft.",
    img: "https://customer-assets.emergentagent.com/job_vespa-basel-relaunch/artifacts/nbewz2oq_imgi_1_GTS-Super.png",
    bg: "bg-[#fff3f1]",
  },
  {
    to: "/pony-mofa",
    overline: "Kult",
    title: "Pony Mofa",
    text: "GTX & Cross — das Schweizer Kult-Mofa lebt weiter.",
    img: "https://customer-assets.emergentagent.com/job_vespa-basel-relaunch/artifacts/7hppphkn_imgi_1_Pony_GTX_Blau_-neues-Logo-Tankdeckel-2023-scaled.jpg",
    bg: "bg-[#eef2f7]",
  },
  {
    to: "/zubehoer",
    overline: "Il Lusso",
    title: "Zubehör Deluxe",
    text: "Helme, Leder, Merchandising — italienische Eleganz.",
    img: "https://customer-assets.emergentagent.com/job_vespa-basel-relaunch/artifacts/bbyn0hev_imgi_1_Banner_Zubehoer.png",
    bg: "bg-[#0d1a2e]",
    dark: true,
  },
  {
    to: "/casa-markus",
    overline: "Besuch",
    title: "Casa Markus",
    text: "Hauptstrasse 74 · Binningen. Termin & Beratung.",
    img: "https://customer-assets.emergentagent.com/job_5adba607-3cb4-4890-a176-530c0c902f8d/artifacts/kkkl20b5_imgi_1_IMG_1653-1-scaled.jpg",
    bg: "bg-[#eef0ec]",
  },
];

export default function ExploreGrid() {
  return (
    <section className="section bg-[var(--cream)]" data-testid="explore-grid">
      <div className="container-wide">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="overline">Entdecken</span>
            <h2 className="h-display text-5xl md:text-6xl lg:text-7xl mt-6 text-[var(--anthracite)] max-w-[16ch]">
              Sechs Wege durch <span className="italic-accent text-[var(--sage-dark)]">unsere Welt.</span>
            </h2>
          </div>
          <p className="text-[var(--muted-fg)] max-w-md leading-relaxed">
            Jede Seite erzählt einen Teil unserer Geschichte. Klicken Sie sich durch — oder
            besuchen Sie uns persönlich.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {CARDS.map((c, i) => (
            <motion.div
              key={c.to}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: i * 0.06, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            >
              <Link
                to={c.to}
                className={`group relative block overflow-hidden ${c.bg} aspect-[4/5] card-clean`}
                data-testid={`explore-card-${c.to.replace("/", "")}`}
              >
                <div className="absolute inset-0 grain" />
                <div className="absolute inset-0 flex items-center justify-center p-10">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="max-w-full max-h-[70%] object-contain transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div
                  className={`absolute bottom-0 left-0 right-0 p-7 md:p-8 ${
                    c.dark
                      ? "bg-gradient-to-t from-black/80 to-transparent text-[var(--cream)]"
                      : "bg-gradient-to-t from-white/85 to-transparent text-[var(--anthracite)]"
                  }`}
                >
                  <span className={`overline text-[10px] ${c.dark ? "!text-white/70" : ""}`}>{c.overline}</span>
                  <div className="mt-2 flex items-end justify-between gap-4">
                    <div>
                      <h3 className="font-serif text-3xl md:text-4xl leading-none">{c.title}</h3>
                      <p
                        className={`text-sm mt-2 ${
                          c.dark ? "text-white/70" : "text-[var(--muted-fg)]"
                        } max-w-[24ch]`}
                      >
                        {c.text}
                      </p>
                    </div>
                    <span
                      className={`w-11 h-11 grid place-items-center transition-all duration-500 group-hover:rotate-45 shrink-0 ${
                        c.dark
                          ? "bg-[var(--cream)] text-[var(--anthracite)]"
                          : "bg-[var(--anthracite)] text-[var(--cream)]"
                      }`}
                    >
                      <ArrowUpRight size={16} strokeWidth={1.5} />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
